// Hide technical proxy/network messages from the user
export const USER_FRIENDLY_NETWORK_ERROR =
  'Villa kom upp við innlestur. Vinsamlegast reyndu aftur.'

export function toUserFriendlyError(message: string | null): string | null {
  if (!message?.trim()) return null
  const lower = message.toLowerCase()
  if (
    lower.includes('proxy') ||
    lower.includes('localhost') ||
    lower.includes('econnrefused') ||
    lower.includes('enotfound') ||
    lower.includes('fetch failed') ||
    lower.includes('network error') ||
    lower.includes('failed to fetch')
  ) {
    return USER_FRIENDLY_NETWORK_ERROR
  }
  return message
}
